// import
import withRedirectLog from "../../utils/withRedirectLog";
import Product from "../products/[pId]"; // definition

export default withRedirectLog(Product);